import React, { useCallback, useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { DialogForm, IDialogActions, ISnackbarAlert, SnackbarAlert, TextFieldInput} from '../../../shared/components';
import { GenericService } from '../../../shared/services';
import { ListId, LocalStorange } from '../../../shared/environment';
import { ResumeDTO, UserDTO, ValueListDTO } from '../../../shared/interfaces';
import { useTranslation } from 'react-i18next';

interface IImportProps {
    data: any;
    setIsOpenMaintenance: (value: boolean) => void;
    isOpenMaintenance: boolean;
    setActionExecuted: (value: boolean) => void;
}

export const Import: React.FC<IImportProps> = ({ data, isOpenMaintenance, setIsOpenMaintenance, setActionExecuted }) => {
    const [resumeDTO, setResumeDTO] = useState<ResumeDTO>();

    const [loading, setLoading] = useState(false);
    const [snackBarAlert, setSnackBarAlert] = useState<ISnackbarAlert>();
    const [isOpenMessage, setIsOpenMessage] = useState(false);
    const [isClose, setIsClose] = useState(false);

    const userInfo = JSON.parse(localStorage.getItem(LocalStorange.USERINFO) || '');
    const { t } = useTranslation();

    useEffect(() => {
        setResumeDTO({
            ...resumeDTO,
            id: '',
            name: '',
            jobTitleId: ListId.talentsphere.resume.startJobTileId,
            seniorityId: '',
            email: '',
            cellPhone: '',
            resume: '',
            resumeFile: '',
            statusId: ListId.talentsphere.resume.availableStatuId,
            completeAddress: '',
            linkedin: '',
            personalInformation: '',
            experienceTime: '',
            hardSkills: '',
            professionalExperience: '',
            professionalExperiencePerHardSkill: '',
            validationQuestions: '',
            validationQuestionsAndAnswers: '',
            companyId: userInfo.user.companyId
        } as ResumeDTO);

    }, [data, isOpenMaintenance]);

    const handleImportClick = useCallback(async () => {
        const dto = resumeDTO as ResumeDTO;

        dto.statusId = ListId.talentsphere.resume.availableStatuId,
        dto.companyId = userInfo.user.companyId;
        dto.createdById = userInfo.user.id;

        GenericService.PostGenericAsync1('talentsphere.resume', 'Import', dto, setActionExecuted, setLoading, showMessage, setResumeDTO);
    }, [resumeDTO]);

    function showMessage(message: string, type: 'error' | 'info' | 'success' | 'warning') {

        const msg: ISnackbarAlert = {
            id: 'message',
            message: message,
            type: type,
        };
        setSnackBarAlert(msg);
        setIsOpenMessage(true);
    }

    const actions: IDialogActions[] = [
        { id: 'import', text: t('import.dialogActions.import'), icon: 'publish_outlined', iconColor: 'primary', setAction: handleImportClick, isClose: isClose },
        { id: 'close', text: t('import.dialogActions.close'), icon: 'close_outlined', iconColor: 'secondary', setAction: () => void undefined },
    ];

    return (
        <React.Fragment>
            {isOpenMessage && (
                <SnackbarAlert
                    snackBarAlert={snackBarAlert}
                    setIsOpen={setIsOpenMessage}
                    isOpen={isOpenMessage}
                />
            )}
            <DialogForm
                title={t('import.dialogForm.title')}
                icon='publish_outlined'
                setIsOpen={setIsOpenMaintenance}
                isOpen={isOpenMaintenance}
                fullWidth={true}
                maxWidth={'lg'}
                actions={actions}
                loading={loading}
            >
                <React.Fragment>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={12}>
                            <TextFieldInput
                                id='resume'
                                label={t('import.textFieldInput.resume')}
                                value={resumeDTO?.resume}
                                setValue={setResumeDTO}
                                obj={resumeDTO}
                                required={true}
                                multiline={true}
                                rows={30}
                            />
                        </Grid>
                    </Grid>
                </React.Fragment>
            </DialogForm >
        </React.Fragment >
    );
};